/* =========================================================
	SITE-WIDE SCRIPTS
========================================================= */

/* MARK: Animate on scroll
----------------------------------------------- */
// Styles live in src/css/utilities/animate-on-scroll.css
const animateObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		// Animate once, then stop watching
		// animateobserver.unobserve(entry.target);

		// Reset on exit so it animates again on the next entry
		entry.target.dataset.state = entry.isIntersecting ? "visible" : "hidden";
	});
}, {
	// Trigger slightly before the element reaches the bottom edge
	// rootMargin: "0px 0px -10% 0px",
	rootMargin: "0px 0px 0px 0px",
});

document.querySelectorAll("[data-animate]").forEach((el) => animateObserver.observe(el));


/* MARK: Mailchimp signup
----------------------------------------------- */
// Posts to /subscribe.php on our own domain, which adds the contact through
// Mailchimp's API, so visitors stay on the page and tracker blockers can't
// interfere. If that fails outright, falls back to a normal submit to
// Mailchimp's own form. Replace with Formie's Mailchimp integration in Craft.
document.querySelectorAll("form[action*='list-manage.com/subscribe/post']").forEach((form) => {
	const status = form.parentElement.querySelector("[data-part='status']");
	const submitButton = form.querySelector("[type='submit']");

	form.addEventListener("submit", async (event) => {
		event.preventDefault();

		submitButton.disabled = true;
		status.textContent = "";
		delete status.dataset.state;

		let response;

		try {
			const request = await fetch("/subscribe.php", {
				method: "POST",
				body: new FormData(form),
			});
			response = await request.json();
		} catch {
			// Network failure, missing script or a non-JSON server error.
			// Bypasses this listener and posts to Mailchimp's page as usual
			form.submit();
			return;
		}

		if (response.result === "success") {
			form.hidden = true;
			status.dataset.state = "success";
			status.textContent = status.dataset.successMessage;
		} else {
			submitButton.disabled = false;
			status.dataset.state = "error";
			status.textContent = response.msg || "Something went wrong. Please try again.";
		}
	});
});


/* MARK: Modals
----------------------------------------------- */
// Any link to a <dialog>'s id opens it, so #id URLs are shareable
function getDialog(hash) {
	const element = hash.length > 1 && document.getElementById(hash.slice(1));

	return element instanceof HTMLDialogElement ? element : null;
}

document.addEventListener("click", (event) => {
	const link = event.target.closest("a[href^='#']");
	const dialog = link && getDialog(link.hash);

	if (dialog) {
		event.preventDefault();
		dialog.showModal();
	}
});

// Open on load when the URL points at a dialog (e.g. /#privacy-policy)
getDialog(location.hash)?.showModal();

// Close on backdrop click; the dialog has no padding, so a click
// landing on the dialog element itself is outside its content
document.querySelectorAll("dialog.modal").forEach((dialog) => {
	dialog.addEventListener("click", (event) => {
		if (event.target === dialog) dialog.close();
	});

	// Clear a shared #id from the URL once its dialog is closed; replaceState
	// avoids adding a history entry or jumping the page
	dialog.addEventListener("close", () => {
		if (location.hash === `#${dialog.id}`) {
			history.replaceState(null, "", location.pathname + location.search);
		}
	});
});
